module.exports = __webpack_public_path__ + "img/vn.0fba9c9c.svg";